import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    const authToken = this.authService.getToken();
    const authRequest = req.clone({
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + authToken
      }),
    });
    return next.handle(authRequest);
    // if (req.url === 'http://propifydemo.pythonanywhere.com/api/api-token-auth/') {
    //   const authRequest = req.clone({

    //   });
    //   return next.handle(authRequest);

    // } else if (req.url === 'http://propifydemo.pythonanywhere.com/api/v1/get_project/') {

    //   const authRequest = req.clone({
    //     headers: req.headers.set('Authorization', 'Token ' + authToken)
    //   });
    //   return next.handle(authRequest);

    // } else {

    //   const authRequest = req.clone({
    //     headers: new HttpHeaders({
    //       'Authorization': 'Token ' + authToken,
    //       'type': localStorage.getItem('type')
    //     }),
    //   });
    //   return next.handle(authRequest);

    // }

  }
}
